import { createContext, useContext, useEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './ModalGlobal.module.scss';

const ModalContext = createContext(null);

const ModalProvider = ({ children }) => {
  const containerRef = useRef(null);

  return (
    <ModalContext.Provider value={containerRef}>
      {children}
      <div
        ref={containerRef}
        className={`${styles.Container} __ModalGlobal__`}
      />
    </ModalContext.Provider>
  );
};

const useModal = () => {
  return useContext(ModalContext);
};

const ModalGlobal = ({ children }) => {
  const containerRef = useModal();
  const el = useMemo(() => document.createElement('div'), []);

  useEffect(() => {
    const container = containerRef.current;

    container.appendChild(el);

    return () => container.removeChild(el);
  }, [containerRef, el]);

  return createPortal(children, el);
};

export default ModalProvider;
export { useModal, ModalGlobal };
